import React, { useEffect, useState } from 'react';
import { BlockPreviewComponent } from '../../lib/declarations/EditorComponentTypes';
import { useCurrentBlock } from '../CurrentBlockProvider';
import { VideoBlock } from '../../../declarations/models/blocks/VideoBlock';
import { DMArtifact } from '../../../declarations/models/DMMediaModel';
import { Api } from '../../../services/Api';

export const VideoBlockPreview: BlockPreviewComponent = () => {
  const { block } = useCurrentBlock();
  const currentBlock = block as VideoBlock;
  const [dmArtifact, setDMArtifact] = useState<DMArtifact>();
  const [videoFile, setVideoFile] = useState<any>(undefined);

  const media = currentBlock?.mediaobject;

  const getBodyOrDescription = (text: string, layout: string) => {
    return text;
  };

  useEffect(() => {
    if (currentBlock.dmItem) {
      if (currentBlock.dmItem.uniqueId) {
        const ctx = Api.getDMArtifact(currentBlock.dmItem.uniqueId);

        ctx
          .fetchDirect(null)
          .then((res) => !!res && setDMArtifact(res))
          .finally(ctx.abort);
      }
    } else setDMArtifact(undefined);
  }, [currentBlock.dmItem, currentBlock.dmItem?.uniqueId]);

  useEffect(() => {
    if (dmArtifact && dmArtifact.files) {
      const foundVideoFile = dmArtifact.files.find((file) => file.fileType === 'Video' || file.fileType === 'video');
      setVideoFile(foundVideoFile);
    } else {
      setVideoFile(undefined);
    }
  }, [dmArtifact]);

  return (
    <>
      <div className='article__grid'>
        <div className='article__bodytext'>
          {currentBlock?.visibletitle && <h2>{currentBlock?.title}</h2>}
          <p>{currentBlock?.body}</p>
        </div>
      </div>
      {currentBlock.source !== 'external' && (
        <div className={`module module--video width--${currentBlock?.width || 'auto'} `}>
          {currentBlock?.video?.id && (
            /* eslint-disable-next-line jsx-a11y/media-has-caption */
            <video controls poster={currentBlock?.video?.content?.poster?.url || currentBlock?.video?.url || ''}>
              <source src={currentBlock?.video?.play_urls?.mp4} type='video/mp4' />
            </video>
          )}
          {dmArtifact?.files && dmArtifact.files.length > 0 && videoFile && (
            /* eslint-disable-next-line jsx-a11y/media-has-caption */
            <video
              controls
              poster={
                dmArtifact?.images && dmArtifact.images.length > 0 && dmArtifact.images[0]?.mediaId
                  ? `https://ems.dimu.org/image/${dmArtifact.images[0].mediaId}`
                  : undefined
              }>
              <source
                src={`https://ems.dimu.org/multimedia/${videoFile?.mediaId}.mp4?mmid=${videoFile?.mediaId}`}
                type='video/mp4'
              />
            </video>
          )}
          <div className='module__foot'>
            {currentBlock?.video && !currentBlock?.video?.local?.disableCredits && (
              <div className='video__caption'>
                {currentBlock?.video.local?.caption || currentBlock.video.content?.caption || ''}
                {currentBlock?.video?.content?.credits && (
                  <span className='media__credit  caption--credit'>
                    {currentBlock?.video?.content?.credits &&
                      currentBlock?.video?.content?.credits?.length > 0 &&
                      currentBlock?.video?.content?.credits?.map(
                        (credit) =>
                          credit?.name && (
                            <span className={credit?.type} key={credit?.name}>
                              {credit?.name} &nbsp;
                            </span>
                          ),
                      )}
                  </span>
                )}
              </div>
            )}

            {currentBlock?.dmItem && <div className='video__caption '>DM-link + Eier</div>}
          </div>
        </div>
      )}
      {currentBlock.source === 'external' && (
        <div className={`module module--video width--${currentBlock?.width || 'auto'} `}>
          <p className=' preview__blockmessage info' style={{ marginTop: '2em', marginBottom: '2em' }}>
            VIDEO: Eksternt innhold fra <strong>{currentBlock?.provider || '----'}</strong> vises kun i sluttportal.
          </p>
        </div>
      )}
    </>
  );
};

export default VideoBlockPreview;
